import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import News from './News/News';
import logo from "../Header/Images/RMB-Strip-Jaipur.png";
import { MdSpaceDashboard } from "react-icons/md";
import { MdPostAdd } from "react-icons/md";
import Member from './Member';
import { FaUsers } from "react-icons/fa";
import HomeBanner from './Banners/HomeBanner';
import { IoMdArrowDropdownCircle } from "react-icons/io";
import { IoImagesSharp } from "react-icons/io5";
import { PiGiftBold } from "react-icons/pi";

import { CgArrowLongRightC } from "react-icons/cg";
import { MdRateReview } from "react-icons/md";

import AboutBanner from './Banners/AboutBanner';
import MemberBanner from './Banners/MemberBanner';
import MeetingsBanner from './Banners/MeetingsBanner';
import DirectorsBanner from './Banners/DirectorsBanner';
import ContactBanner from './Banners/ContactBanner';
import { MdOutlineBusinessCenter } from "react-icons/md";
import { TfiGallery } from "react-icons/tfi";
import Gallery from './Gallery/Gallery';
import Testimonials from './Testimonial/Testimonials';
import { PiSelectionBackgroundFill } from "react-icons/pi";
import { GoCrossReference } from "react-icons/go";

import { GiOpenFolder } from "react-icons/gi";
import About from './Pages/About';
import RMBLeader from './Pages/RMBLeader';
import RMBJaipur from './Pages/RMBJaipur';
import MemberPage from './Pages/MemberPage';
import MeetingPage from './Pages/MeetingPage';
import LeadershipPage from './Pages/LeadershipPage';
import ContactPage from './Pages/ContactPage';
import GetInTouch from './Form/GetInTouch';
import { BiSolidContact } from "react-icons/bi";
import Point from './Points/Point';
import Attendance from './Attendance/Attendance';
import { PiPresentationChart } from "react-icons/pi";

import { RiLogoutBoxLine } from "react-icons/ri";
import Report from './Report/Report';

import { TbReportAnalytics } from "react-icons/tb";
import Business from './Business/Business';
import Reference from './Reference/Reference';
import DashbordHome from './DashbordHome/DashbordHome';
import Chapter from './Chapter/Chapter';


import { FaCodeBranch } from "react-icons/fa6";
import Eventregisterform from './EventRegisterform/Eventregisterform';
import YT from './Youtube/YT';
import AdminDragBuilder from './CustomForm/AdminDragBuilder';


interface UserDetails {
  id: number;
  name: string;
  email: string;
  // Add other fields as per your database schema
}

const Dashboard = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [name, setName] = useState<string | null>(null); // Initialize name state
  const navigate = useNavigate(); // Initialize navigate
  const[tabs, setTabs]  = useState<string>("Dashboard");
  const[userdeatils ,setUserdeatils] = useState<UserDetails | null>(null);

   const [menuOpen, setMenuOpen] = useState(false);


  const[bannerMenu,setBannerMenu] = useState<Boolean>(false);
  const[pageMenu,setPageMenu] = useState<Boolean>(false);

  useEffect(() => {
    const validateSession = async () => {
      try {
        const response = await axios.get(`${api}/auth/dashboard`, {
          withCredentials: true,
        });
        // //console.log('Dashboard data:', response.data); // Check response data

        const uid = response.data.userId;
        // //console.log(`Requesting user details with URL: ${api}/auth/user/${uid}`);

        // //console.log('id is here:', response.data.userId );
        const userResponse = await axios.get(`${api}/auth/user/${uid}`, {
          withCredentials: true,
        });
        setUserdeatils(userResponse.data);
        // //console.log("user response",userResponse);
        setName(response.data.userId); // Set name from response
      } catch (error: any) {
        // console.error('Session validation failed:', error.response?.data || error.message);
        navigate('/login'); // Redirect to login if session validation fails
      }
    };

    validateSession();
  }, [navigate]);

  return (
    <div>
      <div className="flex relative bg-[#CBD5E0]">
        
  {/* Sidebar Section */}
  <div className={`fixed top-0 left-0 h-screen w-[70%] lg:w-[18%] bg-darkblue text-white z-40 transform ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 transition-transform duration-300`}>
    {/* Logo */}

    <div className="w-[230px]  top-4 hidden">
      <img
        src={logo}
        alt="Logo"
        className="rounded-lg drop-shadow-2xl bg-white p-2"
      />
    </div>

    {/* Dashboard Tab */}
    <div className='w-full overflow-y-auto scrollbar-hide  h-[93lvh] mt-3'>
    <div
      className={`w-full h-[48px] flex  cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Dashboard" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Dashboard")}
    >
      <MdSpaceDashboard className="text-2xl" /> <h5>Dashboard</h5>
    </div>

    
    {/*Pages  */}

    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 relative text-base items-center hover:text-[#FDBC12] ${
        tabs === "" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setPageMenu(!pageMenu)}
    >
      <GiOpenFolder className="text-2xl" /> <h5>Pages 
      </h5><IoMdArrowDropdownCircle  className='absolute right-5'/>
      
    </div>
    {pageMenu && (
        <ul className='w-full pl-12'>

          {/* About RMB PAge */}
          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "AboutRMB" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('AboutRMB')}><CgArrowLongRightC />
 About RMB  </li>

 {/* RMB Leader Page */}

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "RMBLeader" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('RMBLeader')}><CgArrowLongRightC />
 RMB Leaders </li>

 {/* Member page */}

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "MemberPage" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('MemberPage')}><CgArrowLongRightC />
 Member </li>

 {/* RMBJaipur */}

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "RMBJaipur" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('RMBJaipur')}><CgArrowLongRightC />
 RMB Jaipur </li>

 {/* Meeting */}


          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "MeetingPage" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('MeetingPage')}><CgArrowLongRightC />
 Meetings </li>


          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "LeadershipPage" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('LeadershipPage')}><CgArrowLongRightC />
 Leadership Team </li>

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "ContactPage" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('ContactPage')}><CgArrowLongRightC />
 Contact </li>

        </ul>
      )}


{/* Testimonial Tab */}
    
<div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Testimonial" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Testimonial")}
    >
      <MdRateReview className="text-2xl" /> <h5>Testimonial</h5>
    </div>

    {/* Gallery Tab */}
    
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Gallery" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Gallery")}
    >
      <IoImagesSharp className="text-2xl" /> <h5>Gallery</h5>
    </div>
       
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "YT" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("YT")}
    >
      <IoImagesSharp className="text-2xl" /> <h5>You Tube</h5>
    </div>


{/* Form Tab */}
    
<div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "FormDeatils" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("FormDeatils")}
    >
      <BiSolidContact className="text-2xl" /> <h5>Form Details</h5>
    </div>

<div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "EventRegisterForm" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("EventRegisterForm")}
    >
      <BiSolidContact className="text-2xl" /> <h5>EventRegisterForm</h5>
    </div>



    {/*Banners  */}

    <div
      className={`w-full h-[48px] flex cursor-pointer relative text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setBannerMenu(!bannerMenu)}
    >
      <PiSelectionBackgroundFill className="text-2xl" /> <h5>Banners 
      </h5><IoMdArrowDropdownCircle  className='absolute right-5'/>
      
    </div>
    {bannerMenu && (
        <ul className='w-full pl-12'>

          {/* Home banner */}
          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "HomeBanner" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('HomeBanner')}><CgArrowLongRightC />
 Home Banner </li>

 {/* About Banner */}

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "AboutBanner" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('AboutBanner')}><CgArrowLongRightC />
 About Banner </li>

 {/* Member Banner */}

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "MemberBanner" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('MemberBanner')}><CgArrowLongRightC />
 Member Banner </li>

 {/* Meeting Banner */}

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "MeetingBanner" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('MeetingBanner')}><CgArrowLongRightC />
 Meeting Banner </li>

 {/* Director Banner */}

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "DirectorBanner" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('DirectorBanner')}><CgArrowLongRightC />
 Director Banner </li>

 {/* Contact Banner */}

          <li className={`w-full h-[34px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-sm items-center hover:text-[#FDBC12] ${
        tabs === "ContactBanner" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`} onClick={()=>setTabs('ContactBanner')}><CgArrowLongRightC />
 Contact  Banner </li>

        </ul>
      )}


    {/* News Tab */}
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "News" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("News")}
    >
      <MdPostAdd className="text-2xl" /> <h5>News</h5>
    </div>
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Member" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Member")}
    >
      <FaUsers className="text-2xl" /> <h5>Member</h5>
    </div>
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Point" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Point")}
    >
      <PiGiftBold className="text-2xl" /> <h5>Point</h5>
    </div>
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Attendance" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Attendance")}
    >
      <PiPresentationChart className="text-2xl" /> <h5>Attendance</h5>
    </div>
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Report" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Report")}
    >
      <TbReportAnalytics className="text-2xl" /> <h5>Report</h5>
    </div>
    
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "BusinessActivity" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("BusinessActivity")}
    >
      <MdOutlineBusinessCenter className="text-2xl" /> <h5>Business Activity</h5>
    </div>
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Reference" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Reference")}
    >
      <GoCrossReference className="text-2xl" /> <h5>Reference</h5>
    </div>
    <div
      className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
        tabs === "Chapter" ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
      }`}
      onClick={() => setTabs("Chapter")}
    >
      <FaCodeBranch className="text-2xl" /> <h5>Chapter</h5>
    </div>
    </div>
    <div
    className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] `}
    onClick={()=>{window.location.href = '/login'}}
  >
    <div className="text-2xl"><RiLogoutBoxLine/></div> <h5>Logout</h5>
  </div>
  </div>

  {/* Header for Mobile */}
  <div className="lg:hidden bg-darkblue text-white px-4 py-3 flex items-center justify-between fixed top-0 left-0 w-full z-10">
      <img src={logo} alt="Logo" className="w-[50%] object-contain drop-shadow-2xl" />
      <button
        className="relative w-8 h-8 focus:outline-none"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {/* Animated Hamburger Icon */}
        <div
          className={`relative w-8 h-1 bg-white rounded transition-transform duration-300 transform ${
            menuOpen ? "rotate-45 translate-y-[10px]" : ""
          }`}
        ></div>
        <div
          className={`relative w-8 h-1 bg-white rounded my-[6px] transition-opacity duration-300 ${
            menuOpen ? "opacity-0" : "opacity-100"
          }`}
        ></div>
        <div
          className={`relative w-8 h-1 bg-white rounded transition-transform duration-300 transform ${
            menuOpen ? "-rotate-45 -translate-y-[10px]" : ""
          }`}
        ></div>
      </button>
    </div>
   {/* Overlay for Small Screens */}
   {menuOpen && (
    <div
      className="fixed inset-0 bg-black opacity-50 z-10 lg:hidden"
      onClick={() => setMenuOpen(false)}
    />
  )}

  {/* Content Section */}
  <div className={`lg:ml-[18%] lg:w-[82%] bg-[#CBD5E0] min-h-screen transition-all duration-300 lg:mt-0 mt-24 ml-[0%] w-[100%]`}>
    {tabs === "News" && <News />}
    {tabs === "Dashboard" && <DashbordHome />}
    {tabs === "Member" && <Member />}
    {tabs ==="HomeBanner" && <HomeBanner />}
    {tabs ==="AboutBanner" && <AboutBanner />}
    {tabs ==="MemberBanner" && <MemberBanner />}
    {tabs ==="MeetingBanner" && <MeetingsBanner />}
    {tabs ==="DirectorBanner" && <DirectorsBanner />}
    {tabs ==="ContactBanner" && <ContactBanner />}
    {tabs ==="Gallery" && <Gallery />}
    {tabs ==="Testimonial" && <Testimonials />}
    {tabs ==="AboutRMB" && <About />}
    {tabs ==="RMBLeader" && <RMBLeader />}
    {tabs ==="RMBJaipur" && <RMBJaipur />}
    {tabs ==="MemberPage" && <MemberPage />}
    {tabs ==="MeetingPage" && <MeetingPage />}
    {tabs ==="LeadershipPage" && <LeadershipPage/>}
    {tabs ==="ContactPage" && <ContactPage/>}
    {tabs ==="FormDeatils" && <GetInTouch/>}
    {tabs ==="Point" && <Point/>}
    {tabs ==="Attendance" && <Attendance/>}
    {tabs ==="Report" && <Report/>}
    {tabs ==="BusinessActivity" && <Business/>}
    {tabs ==="Reference" && <Reference/>}
    {tabs ==="Chapter" && <Chapter/>}
    {tabs ==="EventRegisterForm" && <AdminDragBuilder/>}
    {tabs ==="YT" && <YT/>}

  </div>
</div>

       
      
      
    </div>
  );
};


type MenuItemProps = {
  label: string;
  activeTab: string;
  tabKey: string;
  icon: React.ReactNode; // Type for JSX/React components
  onClick: () => void;   // Type for a function with no arguments and no return value
};
const MenuItem: React.FC<MenuItemProps> = ({ label, activeTab, tabKey, icon, onClick }) => (
  <div
    className={`w-full h-[48px] flex cursor-pointer text-white justify-start pl-4 gap-4 text-base items-center hover:text-[#FDBC12] ${
      activeTab === tabKey ? "border-r-4 border-[#FDBC12] !text-[#FDBC12]" : ""
    }`}
    onClick={onClick}
  >
    <div className="text-2xl">{icon}</div> <h5>{label}</h5>
  </div>
);

export default Dashboard;
